import React from 'react';

const TrendingInterests = ({ topUserInterests }) => {
  return (
    <div className="trending-interests">
      <div className="trending-interests-header">
        <span className="header-interest">Trending interests</span>
        <span className="header-count"># Users</span>
      </div>

      <ul>
        {topUserInterests.map((item, index) => (
          <li key={index}>
            <span className="trending-interest-name">{item.user_interest}</span>
            <span className="trending-interest-count">{item.count}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TrendingInterests;
